<template>
    <v-container grid-list-md>
        <v-form
            v-if="step === 'followup'"
            ref="studyFollowUp"
            v-model="studyFollowUpValid"
            lazy-validation
        >

            <v-layout row justify-space-between>
                <h3 class="headline mb-4">Configurer un suivi</h3>
                <v-btn v-if="$route.name === 'study.definition.edit'" flat @click="deleteDialog = true">
                    <v-icon>delete</v-icon>
                </v-btn>
            </v-layout>
            <v-layout>
                <v-flex xs6>
                    <v-checkbox v-model="follow_up_preop"
                                hide-details
                                label="Pre-op ?"
                                class="mb-4"
                    />
                    <template
                        v-if="!follow_up_preop"
                    >
                        <v-text-field
                            v-model="follow_up_frequency"
                            :rules="[v => (!!v && follow_up_preop === false) || 'Le champs est requis']"
                            label="Fréquence"
                            :disabled="follow_up_preop"
                        >

                        </v-text-field>
                        <v-select
                            v-model="follow_up_period"
                            :rules="[v => (!!v && follow_up_preop === false) || 'Le champs est requis']"
                            :items="[
                                {text: 'semaine', value: 'semaine'},
                                {text: 'mois', value: 'mois'},
                                {text: 'an(s)', value: 'an'},
                            ]"
                            label="Période"
                            :disabled="follow_up_preop"
                        ></v-select>
                    </template>
                </v-flex>

                <v-flex text-xs-right>
                    <v-btn :disabled="!studyFollowUpValid" color="success" @click="validate">Suivant
                    </v-btn>

                </v-flex>
            </v-layout>

        </v-form>
        <v-form
            v-else
            ref="studyFollowUpScore"
            v-model="studyFollowUpScoreValid"
            lazy-validation
        >

            <h3 class="headline mb-4">Configurer ses scores</h3>
            <h4 class="mb-4">Temporalité configurée : {{ follow_up_preop ? 'Pre-op' : follow_up_frequency + ' ' + follow_up_period }}</h4>
            <v-divider></v-divider>
            <v-layout>
                <v-flex md5>
                    <v-checkbox
                        v-if="scores.length"
                        v-for="(score, index) in scores"
                        :key="index"
                        v-model="follow_up_scores"
                        hide-details
                        :label="score.name"
                        :value="score"
                        class="mt-0"
                    />
                </v-flex>
                <v-list md6>
                    <template v-for="(score, index) in follow_up_scores">
                        <v-list-tile :key="score.id">
                            <v-list-tile-content>
                                <v-list-tile-title>{{ score.name }}</v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="margin-bottom: 16px">
                                <v-icon
                                    v-if="index > 0"
                                    color="secondary"
                                    @click="moveUp(score)"
                                >mdi-chevron-up
                                </v-icon>
                                <v-icon
                                    v-if="index < follow_up_scores.length -1"
                                    color="secondary"
                                    @click="moveDown(score)"
                                >mdi-chevron-down
                                </v-icon>
                            </v-list-tile-action>

                        </v-list-tile>
                        <v-divider
                            v-if="index + 1 < follow_up_scores.length"
                            :key="'divider_' + index"
                        ></v-divider>
                    </template>
                </v-list>
                <v-flex text-xs-right>
                    <v-btn :disabled="!studyFollowUpScoreValid" color="success" @click="validateScore">Enregistrer
                    </v-btn>

                </v-flex>
            </v-layout>
        </v-form>
        <v-dialog v-model="deleteDialog" persistent max-width="480">
            <v-card>
                <v-card-title class="headline">Supprimer l'étude</v-card-title>
                <v-card-text>Voulez-vous vraiment supprimer la temporalité ?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="deleteDialog = false">Annuler</v-btn>
                    <v-btn color="primary" text @click="deleteFollowUp">Oui, supprimer</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>

</template>

<script>
import {mapActions, mapState, mapMutations, mapGetters} from 'vuex'


export default {
    name: "StudyDefinitionForm",
    data() {
        return {
            mode: 'create',
            studyFollowUpValid: false,
            studyFollowUpScoreValid: false,
            step: 'followup',
            deleteDialog: false
        }
    },
    computed: {
        ...mapState('studies', {
            selectedStudy: state => state.selectedStudy,
            selectedFollowUpDefinition: state => state.selectedFollowUpDefinition,
            scores: state => state.scores
        }),
        follow_up_preop: {
            get() {
                return this.$store.state.studies.formFollowUp.preop
            },
            set(value) {
                this.setPreop(value)
            }
        },
        follow_up_frequency: {
            get() {
                return this.$store.state.studies.formFollowUp.frequency
            },
            set(value) {
                this.setFrequency(value)
            }
        },
        follow_up_period: {
            get() {
                return this.$store.state.studies.formFollowUp.period
            },
            set(value) {
                this.setPeriod(value)
            }
        },
        follow_up_scores: {
            get() {
                return this.$store.state.studies.formFollowUp.scoresForm
            },
            set(value) {
                this.setScores(value)
            }
        }
    },
    created() {
        this.getAllScoresByType('study')
        if (this.$route.params.id && this.$route.params.definition) {
            this.mode = "edit"

            this.setSelectedStudyId(this.$route.params.id)
            this.setSelectedFollowUpDefinitionId(this.$route.params.definition)
            this.loadStudyFollowUp()
        } else {
            this.mode = "create"
        }
    },
    mounted() {

        if (this.mode === 'create') {
            this.follow_up_preop = false
            this.follow_up_period = ''
            this.follow_up_frequency = 0
            this.follow_up_scores = []
        }
    },
    watch: {
        selectedScores(val) {

        }
    },
    methods: {
        validate() {
            if (this.$refs.studyFollowUp.validate()) {
                this.step = 'step'
            }
        },
        validateScore() {
            if (this.$refs.studyFollowUpScore.validate()) {
                this.submit()
            }
        },
        submit() {

            if (this.mode === 'create') {
                this.createStudyFollowUp().then(response => {
                    this.getStudyInfo()
                    this.$router.replace({name: 'study.view', params: {id: this.selectedStudy.id}})

                }).catch(reason => {
                    //Stay here..
                })
            } else {
                this.updateStudyFollowUp().then(response => {
                    this.getStudyInfo()
                    this.$router.replace({name: 'study.view', params: {id: this.selectedStudy.id}})
                }).catch(reason => {
                    //Stay here..
                })
            }
        },
        deleteFollowUp() {
            this.deleteDialog = false;
            this.deleteStudyFollowUp().then(response => {
                    this.getStudyInfo()
                    this.$router.replace({name: 'study.view', params: {id: this.selectedStudy.id}})
                }
            ).catch(reason => {
            })

        },
        ...mapMutations('studies', {
            setSelectedStudyId: 'setSelectedStudyId',
            setSelectedFollowUpDefinitionId: 'setSelectedFollowUpDefinitionId',
            setFrequency: 'setFollowUpFrequency',
            setPeriod: 'setFollowUpPeriod',
            setPreop: 'setFollowUpPreop',
            setScores: 'setFollowUpScores',
            moveUp: 'moveUpFollowUpScore',
            moveDown: 'moveDownFollowUpScore',
        }),
        ...mapActions('studies', ['getStudyInfo', 'loadStudyFollowUp', 'getAllScores', 'createStudyFollowUp', 'updateStudyFollowUp', 'deleteStudyFollowUp', 'getAllScoresByType'])
    },
}
</script>

<style scoped>

</style>
